// Pure rules for which account an Analytics setting belongs to, so a slow
// response for one account can never leak into another after a switch.
export function isActiveAccount(requestedKey, activeKey) {
  return Boolean(requestedKey) && requestedKey === activeKey
}

export function includeBotsFor(settings, activeKey) {
  return Boolean(settings && settings.includeBots) && isActiveAccount(settings.accountKey, activeKey)
}
